import { render, staticRenderFns } from "./oss-img.vue?vue&type=template&id=d4eeb4ea&scoped=true"
import script from "./oss-img.vue?vue&type=script&lang=js"
export * from "./oss-img.vue?vue&type=script&lang=js"
import style0 from "./oss-img.vue?vue&type=style&index=0&id=d4eeb4ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4eeb4ea",
  null
  
)

export default component.exports